import { render, staticRenderFns } from "./quility-tech.vue?vue&type=template&id=765caf52&"
import script from "./quility-tech.vue?vue&type=script&lang=js&"
export * from "./quility-tech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports